import './index.css'

import State from './State'

import * as d3 from 'd3'
import * as _ from 'lodash'


function resolveInconsistentNames(csv) {
  csv.forEach(d => {
    d['SupplierName'] = d['SupplierName'].trim()
    if(d['SupplierName'] === 'AggregateIQ Data Services Ltd' || d['SupplierName'] === 'AGGREGATEIQ' || d['SupplierName'] === 'Aggregate IQ')
      d['SupplierName'] = 'AggregateIQ'
    if(d['SupplierName'] === 'Soopa Doopa')
      d['SupplierName'] = 'Soopa Doopa Branding Ltd'
  })
}

function resolveDateErrors(csv) {
  csv.forEach(d => {
    if(d['DateIncurred'] === '23/06/2106')
      d['DateIncurred'] = '23/06/2016'
    if(d['DateIncurred'] === '15/06/2106')
      d['DateIncurred'] = '15/06/2016'
    if(d['DateIncurred'] === '30/04/2006')
      d['DateIncurred'] = '30/04/2016'
  })
}
d3.csv('./data/results-reduced.csv', (err, csv) => {
  _.each(csv, d => {d['TotalExpenditure'] = +(d['TotalExpenditure'].replace('£', '').replace(/,/g, ''))})

  resolveInconsistentNames(csv)
  resolveDateErrors(csv)

  State.action('initStateFromHash')
  State.action('updateData', csv)

  State.action('resize')
  // setTimeout(() => {State.action('resize')}, 1000)

  window.addEventListener('resize', () => {State.action('resize')})
})



// WEBPACK FOOTER //
// ./src/index.js